import { render, staticRenderFns } from "./SimpleHeaderBackground.vue?vue&type=template&id=27b3513c&name=simple-header-background&"
import script from "./SimpleHeaderBackground.vue?vue&type=script&lang=js&"
export * from "./SimpleHeaderBackground.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHeaderBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports